document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('[data-lb-slider]');
  if (!sliders.length) return;

  sliders.forEach(initSlider);

  function isMobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function getPerView(slider) {
    const styles = getComputedStyle(slider);
    const raw = isMobile()
      ? styles.getPropertyValue('--lb-columns-mobile')
      : styles.getPropertyValue('--lb-columns-desktop');

    return Math.max(1, parseInt(raw, 10) || (isMobile() ? 2 : 4));
  }

  function getCloneCount(slider, realCount) {
    return Math.min(Math.max(getPerView(slider), 2), realCount);
  }

  async function initSlider(slider) {
    if (slider.dataset.lbUnifiedReady === 'true') return;
    slider.dataset.lbUnifiedReady = 'true';

    const collectionUrl = slider.dataset.collectionUrl;
    const maxProducts = parseInt(slider.dataset.maxProducts || '8', 10);

    const viewport = slider.querySelector('[data-lb-viewport]');
    const track = slider.querySelector('[data-lb-track]');
    const prevBtn = slider.querySelector('[data-lb-prev]');
    const nextBtn = slider.querySelector('[data-lb-next]');

    if (!collectionUrl || !viewport || !track || !prevBtn || !nextBtn) return;

    try {
      const res = await fetch(collectionUrl, {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const productItems = Array.from(
        doc.querySelectorAll('#ResultsList ul.product-grid > li.product-grid__item')
      ).slice(0, maxProducts);

      if (!productItems.length) return;

      const originalSlides = productItems.map(function (item) {
        return isMobile() ? buildMobileSlide(item) : buildBaseSlide(item);
      });

      setupLoopSlider({
        slider,
        viewport,
        track,
        prevBtn,
        nextBtn,
        originalSlides
      });
    } catch (err) {
      console.warn('LB unified product slider failed:', err);
    }
  }

  function buildBaseSlide(item) {
    const slide = document.createElement('div');
    slide.className = 'lb-product-slider__slide';
    slide.setAttribute('data-lb-slide', '');
    slide.appendChild(item.cloneNode(true));
    cleanClone(slide);
    return slide;
  }

  function buildMobileSlide(item) {
    const data = getMobileCardData(item);

    const slide = document.createElement('div');
    slide.className = 'lb-product-slider__slide lb-mobile-loop-slide';
    slide.setAttribute('data-lb-slide', '');

    slide.innerHTML =
      '<div class="lb-mobile-card">' +
        '<a class="lb-mobile-card__image-link" href="' + escapeHtml(data.url) + '" aria-label="Open product">' +
          (
            data.imageSrc
              ? '<img class="lb-mobile-card__image" src="' + escapeHtml(data.imageSrc) + '"' +
                (data.imageSrcset ? ' srcset="' + escapeHtml(data.imageSrcset) + '"' : '') +
                (data.imageSizes ? ' sizes="' + escapeHtml(data.imageSizes) + '"' : '') +
                ' alt="' + escapeHtml(data.imageAlt) + '">'
              : ''
          ) +
        '</a>' +
        '<div class="lb-mobile-card__info-wrap">' +
          cleanupInfoHtml(data.infoHtml, data.url) +
        '</div>' +
      '</div>';

    return slide;
  }

  function getMobileCardData(item) {
    const root =
      item.querySelector('li.product-grid__item') ||
      item.querySelector('.product-grid__item') ||
      item;

    const productUrl =
      root.querySelector('.contents[href]')?.getAttribute('href') ||
      root.querySelector('.product-card__link[href]')?.getAttribute('href') ||
      root.querySelector('a[href]')?.getAttribute('href') ||
      '#';

    const firstImage =
      root.querySelector('slideshow-slide[aria-hidden="false"] img') ||
      root.querySelector('slideshow-slide img') ||
      root.querySelector('.product-media__image') ||
      root.querySelector('.card-gallery img') ||
      root.querySelector('img');

    const infoBlock =
      root.querySelector('.group-block') ||
      root.querySelector('.product-card__information') ||
      root.querySelector('.card-information') ||
      root.querySelector('.group-block-content');

    return {
      url: productUrl,
      imageSrc: firstImage?.getAttribute('src') || '',
      imageSrcset: firstImage?.getAttribute('srcset') || '',
      imageSizes: firstImage?.getAttribute('sizes') || '',
      imageAlt: firstImage?.getAttribute('alt') || '',
      infoHtml: infoBlock ? infoBlock.outerHTML : ''
    };
  }

  function cleanupInfoHtml(html, productUrl) {
    const wrap = document.createElement('div');
    wrap.innerHTML = html || '';

    wrap.querySelectorAll(
      [
        'slideshow-component',
        'slideshow-container',
        'slideshow-slides',
        'slideshow-slide',
        'slideshow-arrows',
        'slideshow-controls',
        '.mobile-card-progress',
        'quick-add-component',
        '.quick-add',
        'add-to-cart-component',
        'product-form-component',
        '.product-grid-view-zoom-out--details'
      ].join(',')
    ).forEach(function (el) {
      el.remove();
    });

    wrap.querySelectorAll('.contents').forEach(function (link) {
      const href = link.getAttribute('href') || productUrl;
      const inner = link.innerHTML;

      if (inner.trim()) {
        const a = document.createElement('a');
        a.href = href;
        a.className = 'lb-mobile-card__text-link';
        a.innerHTML = inner;
        link.replaceWith(a);
      } else {
        link.replaceWith(...link.childNodes);
      }
    });

    wrap.querySelectorAll('a:not(.lb-mobile-card__text-link)').forEach(function (link) {
      if (link.closest('.product-card-swatches')) return;
      link.classList.add('lb-mobile-card__text-link');
    });

    return wrap.innerHTML;
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function cleanClone(node) {
    node.removeAttribute('id');

    node.querySelectorAll('[id]').forEach(function (el) {
      el.removeAttribute('id');
    });

    node.querySelectorAll('style[data-shopify]').forEach(function (el) {
      el.remove();
    });

    node.querySelectorAll('[data-real], [data-clone]').forEach(function (el) {
      el.removeAttribute('data-real');
      el.removeAttribute('data-clone');
    });

    return node;
  }

  function setupLoopSlider(config) {
    const slider = config.slider;
    const viewport = config.viewport;
    const track = config.track;
    const prevBtn = config.prevBtn;
    const nextBtn = config.nextBtn;
    const originalSlides = config.originalSlides;

    const TRANSITION = 'transform 0.45s cubic-bezier(.22,.61,.36,1)';
    const AUTOPLAY_DELAY = isMobile() ? 3200 : 2800;

    let currentIndex = 0;
    let isAnimating = false;
    let autoplayTimer = null;
    let isHovered = false;
    let isTouching = false;
    let isVisible = true;

    let startX = 0;
    let startY = 0;
    let deltaX = 0;
    let isDragging = false;
    let isHorizontal = false;

    viewport.style.touchAction = 'pan-y pinch-zoom';

    buildTrack();

    function getAllSlides() {
      return Array.from(track.children);
    }

    function getRealCount() {
      return originalSlides.length;
    }

    function getRealBounds() {
      const realCount = getRealCount();
      const cloneCount = getCloneCount(slider, realCount);

      return {
        cloneCount: cloneCount,
        firstReal: cloneCount,
        lastReal: cloneCount + realCount - 1,
        realCount: realCount
      };
    }

    function getOffset(index) {
      const slide = getAllSlides()[index];
      return slide ? slide.offsetLeft : 0;
    }

    function setTranslateByIndex(index) {
      track.style.transform = 'translate3d(-' + getOffset(index) + 'px, 0, 0)';
    }

    function jumpTo(index) {
      track.style.transition = 'none';
      currentIndex = index;
      setTranslateByIndex(currentIndex);
      track.offsetHeight;
    }

    function animateTo(index) {
      isAnimating = true;
      currentIndex = index;
      updateControls();

      track.style.transition = TRANSITION;
      setTranslateByIndex(currentIndex);
    }

    function buildTrack() {
      const realCount = getRealCount();
      if (!realCount) return;

      const cloneCount = getCloneCount(slider, realCount);

      const before = originalSlides.slice(-cloneCount).map(function (slide) {
        const clone = slide.cloneNode(true);
        clone.dataset.clone = 'before';
        cleanClone(clone);
        return clone;
      });

      const real = originalSlides.map(function (slide) {
        const clone = slide.cloneNode(true);
        clone.dataset.real = 'true';
        cleanClone(clone);
        return clone;
      });

      const after = originalSlides.slice(0, cloneCount).map(function (slide) {
        const clone = slide.cloneNode(true);
        clone.dataset.clone = 'after';
        cleanClone(clone);
        return clone;
      });

      track.innerHTML = '';

      before.forEach(function (slide) {
        track.appendChild(slide);
      });

      real.forEach(function (slide) {
        track.appendChild(slide);
      });

      after.forEach(function (slide) {
        track.appendChild(slide);
      });

      jumpTo(cloneCount);
      updateControls();
    }

    function normalizeLoop() {
      const bounds = getRealBounds();

      if (currentIndex > bounds.lastReal) {
        jumpTo(bounds.firstReal);
      } else if (currentIndex < bounds.firstReal) {
        jumpTo(bounds.lastReal);
      }
    }

    function next() {
      if (isAnimating) return;
      animateTo(currentIndex + 1);
    }

    function prev() {
      if (isAnimating) return;
      animateTo(currentIndex - 1);
    }

    function updateControls() {
      prevBtn.disabled = isAnimating;
      nextBtn.disabled = isAnimating;
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      stopAutoplay();
      prev();
      startAutoplaySoon();
    });

    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      stopAutoplay();
      next();
      startAutoplaySoon();
    });

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;

      normalizeLoop();
      isAnimating = false;
      updateControls();
    });

    viewport.addEventListener(
      'touchstart',
      function (e) {
        if (!isMobile() || isAnimating) return;

        const t = e.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        deltaX = 0;
        isDragging = true;
        isHorizontal = false;
        isTouching = true;

        stopAutoplay();

        track.style.transition = 'none';
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      function (e) {
        if (!isMobile() || !isDragging) return;

        const t = e.touches[0];
        const dx = t.clientX - startX;
        const dy = t.clientY - startY;

        deltaX = dx;

        if (!isHorizontal) {
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
            isHorizontal = true;
          } else if (Math.abs(dy) > 12 && Math.abs(dy) > Math.abs(dx) * 1.3) {
            isDragging = false;
            track.style.transition = TRANSITION;
            setTranslateByIndex(currentIndex);
            return;
          }
        }

        if (!isHorizontal) return;

        e.preventDefault();

        const base = getOffset(currentIndex);
        track.style.transform = 'translate3d(-' + (base - dx) + 'px, 0, 0)';
      },
      { passive: false }
    );

    viewport.addEventListener(
      'touchend',
      function () {
        if (!isMobile() || !isDragging) {
          isTouching = false;
          startAutoplaySoon();
          return;
        }

        isDragging = false;

        if (!isHorizontal) {
          track.style.transition = TRANSITION;
          setTranslateByIndex(currentIndex);
          isTouching = false;
          startAutoplaySoon();
          return;
        }

        const threshold = 35;

        if (deltaX < -threshold) {
          next();
        } else if (deltaX > threshold) {
          prev();
        } else {
          track.style.transition = TRANSITION;
          setTranslateByIndex(currentIndex);
        }

        setTimeout(function () {
          isTouching = false;
          startAutoplaySoon();
        }, 900);
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchcancel',
      function () {
        if (!isMobile()) return;

        isDragging = false;
        isTouching = false;
        track.style.transition = TRANSITION;
        setTranslateByIndex(currentIndex);
        startAutoplaySoon();
      },
      { passive: true }
    );

    slider.addEventListener('mouseenter', function () {
      isHovered = true;
      stopAutoplay();
    });

    slider.addEventListener('mouseleave', function () {
      isHovered = false;
      startAutoplaySoon();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplaySoon();
      }
    });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        function (entries) {
          const entry = entries[0];
          isVisible = !!entry && entry.isIntersecting;

          if (isVisible) {
            startAutoplaySoon();
          } else {
            stopAutoplay();
          }
        },
        { threshold: 0.25 }
      );

      io.observe(slider);
    }

    let resizeTimer = null;
    let lastMode = isMobile() ? 'mobile' : 'desktop';
    let lastWidth = window.innerWidth;

    window.addEventListener('resize', function () {
      const newWidth = window.innerWidth;
      const newMode = isMobile() ? 'mobile' : 'desktop';

      if (newWidth === lastWidth && newMode === lastMode) return;

      lastWidth = newWidth;

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        const modeChanged = newMode !== lastMode;
        lastMode = newMode;

        stopAutoplay();

        if (modeChanged) {
          location.reload();
        } else {
          jumpTo(currentIndex);
        }

        startAutoplaySoon();
      }, 180);
    });

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function canAutoplay() {
      if (slider.dataset.lbAutoplay !== 'true') return false;
      if (document.hidden) return false;
      if (!isVisible) return false;
      if (isHovered) return false;
      if (isTouching) return false;
      if (isAnimating) return false;
      return true;
    }

    function startAutoplay() {
      stopAutoplay();

      if (!canAutoplay()) return;

      autoplayTimer = setInterval(function () {
        if (!canAutoplay()) return;
        next();
      }, AUTOPLAY_DELAY);
    }

    function startAutoplaySoon() {
      setTimeout(startAutoplay, 500);
    }

    setTimeout(startAutoplay, 1200);
  }
});

